export const Config = {
	database: {
		socket  : '/run/mysqld/mysqld.sock',
		user    : 'pontem',
		password: 'aeth4Ais!Jaipoo7d',
		name    : 'pontem',
		timeout : 5,
		timezone: '+09:00',
	},

	sentry: {
		dsn        : 'https://809c3a6aa01042459639b37b25be4e99@trace.windware.net/4',
		sample_rate: 0.1,
	},

	system: {
		environment: 'development',
		description: '美容学生向けサロン検索サイト ポンテム',
		name       : 'ポンテム',
		mail_from  : 'www-data@pontem-recruit.net',
		notify     : 'server+pontem-recruit.net@windware.com',
		sendmail   : '/usr/sbin/sendmail',
		pid_file   : '/tmp/%s.pid',
	},

	log: {
		threshold: 'info',
	},
}
